export default {
  // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreament: 410,
  // Điều chỉnh TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 411,
  // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 412,
  // Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciation: 413,
  // Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrement: 414,
};
